const state = {
  loggedInUserProfile: {
    myResults: {},
    user: {},
    apiToken: undefined,
    idpToken: undefined,
  },
  userSocialState: undefined,
  pushNotification: {},
  islandProgressionList: {},
  islandProgressionItem: {},
  userCountry: true,
  friendLists: {
    google: undefined,
    facebook: undefined,
    maybe_known: undefined,
  },
  userAfterCollision: undefined,
};

export default state;
